// extracted by mini-css-extract-plugin
export var htmlContent = "HTMLContent-module--htmlContent--3T1Iz";
export var doctorHtmlContent = "HTMLContent-module--doctorHtmlContent--2FHp-";
export var textWithImageHtmlContent = "HTMLContent-module--textWithImageHtmlContent--2qafa";
export var faqAnswer = "HTMLContent-module--faqAnswer--2xF5s";
export var resources = "HTMLContent-module--resources--nveR-";
export var map = "HTMLContent-module--map--3h2Pc";
export var newsPost = "HTMLContent-module--newsPost--17cqJ";